import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Download } from "lucide-react";
import QRCode from "react-qr-code";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const MisBoletosPage = () => {
  const { compradorId } = useParams();
  const navigate = useNavigate();
  const [boletos, setBoletos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (compradorId) {
      fetchBoletos();
    }
  }, [compradorId]);

  const fetchBoletos = async () => {
    try {
      const response = await axios.get(`${API}/boletos/comprador/${compradorId}`);
      setBoletos(response.data);
    } catch (error) {
      console.error("Error fetching boletos:", error);
      toast.error("Error al cargar los boletos");
    } finally {
      setLoading(false);
    }
  };

  const descargarPDF = async (numero_boleto) => {
    try {
      const response = await axios.get(
        `${API}/boletos/pdf/${numero_boleto}`,
        { responseType: "blob" }
      );
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `boleto_${numero_boleto}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      
      toast.success("Boleto descargado exitosamente");
    } catch (error) {
      console.error("Error descargando PDF:", error);
      toast.error("Error al descargar el boleto");
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-warm-bone">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-zuno-wine"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-warm-bone py-12">
      <div className="container mx-auto px-6 md:px-12 lg:px-24 max-w-6xl">
        <Button
          onClick={() => navigate("/")}
          variant="ghost"
          className="mb-8"
          data-testid="back-button"
        >
          <ArrowLeft className="mr-2" size={20} />
          Volver al Inicio
        </Button>

        <h1 className="text-4xl md:text-5xl font-bold text-zuno-wine mb-8">
          Mis Boletos
        </h1>

        {boletos.length === 0 ? (
          <div className="glass-card rounded-3xl p-12 text-center">
            <p className="text-xl text-slate-600">No se encontraron boletos</p>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 gap-8">
            {boletos.map((boleto, index) => (
              <div
                key={boleto.numero_boleto}
                className="ticket-card p-8"
                data-testid={`ticket-card-${index}`}
              >
                <div className="mb-6">
                  <h2 className="text-2xl font-bold text-zuno-wine mb-2">
                    XXX Aniversario
                  </h2>
                  <p className="text-sm text-slate-600">
                    Generación 1993-1996
                  </p>
                </div>

                <div className="ticket-perforation mb-6"></div>

                <div className="flex justify-center mb-6">
                  <div className="bg-white p-4 rounded-xl">
                    <QRCode
                      value={boleto.qr_data}
                      size={200}
                      data-testid={`qr-code-${index}`}
                    />
                  </div>
                </div>

                <div className="text-center mb-6">
                  <p className="text-sm text-slate-600 mb-2">Asistente</p>
                  <p className="font-semibold text-xl text-slate-800">
                    {boleto.nombre_asistente || "N/A"}
                  </p>
                  <p className="text-sm text-slate-600 mt-1">
                    {boleto.tipo_asistente || "Invitado"}
                  </p>
                </div>

                <div className="text-center mb-6">
                  <p className="text-sm text-slate-600 mb-2">Número de Boleto</p>
                  <p className="font-mono font-bold text-xl text-zuno-wine">
                    {boleto.numero_boleto}
                  </p>
                </div>

                <div className="ticket-perforation mb-6"></div>

                <div className="space-y-2 text-sm text-slate-700 mb-6">
                  <p><strong>Fecha:</strong> Sábado 20 de Junio de 2026</p>
                  <p><strong>Hora:</strong> 20:00 horas</p>
                  <p><strong>Lugar:</strong> Terraza Frevo</p>
                  <p><strong>Estado:</strong> <span className={`font-semibold ${
                    boleto.estado === "activo" ? "text-green-600" :
                    boleto.estado === "usado" ? "text-blue-600" :
                    "text-red-600"
                  }`}>{boleto.estado.toUpperCase()}</span></p>
                </div>

                <Button
                  onClick={() => descargarPDF(boleto.numero_boleto)}
                  className="w-full btn-primary"
                  data-testid={`download-btn-${index}`}
                >
                  <Download className="mr-2" size={18} />
                  Descargar PDF
                </Button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MisBoletosPage;
